export default __webpack_public_path__ + "static/media/remove.deae8ec4.svg";